module.exports = __webpack_public_path__ + "static/media/TimeScoreIcon.42f32b8a.svg";